import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

const ChatService = {
  getThreads: async (page = 1, pageSize = 20, showArchived = false) => {
    return await wrapFetch(
      fetch(`/api/chat?page=${page}&pageSize=${pageSize}&showArchived=${showArchived}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: 'application/json',
        },
      }),
    )
  },

  createThread: async (caseNumber, subject, participantIds) => {
    console.log('ChatService: createThread called', { caseNumber, subject })
    const token = getToken()
    console.log('ChatService: Token retrieved', token ? 'Yes' : 'No')

    return await wrapFetch(
      fetch('/api/chat', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          caseNumber: caseNumber ? parseInt(caseNumber) : null,
          subject,
          participantIds,
        }),
      }),
    )
  },

  getMessages: async (threadId, page = 1, pageSize = 50) => {
    return await wrapFetch(
      fetch(`/api/chat/${threadId}/messages?page=${page}&pageSize=${pageSize}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: 'application/json',
        },
      }),
    )
  },

  sendMessage: async (threadId, content) => {
    return await wrapFetch(
      fetch(`/api/chat/${threadId}/messages`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ content }),
      }),
    )
  },

  markRead: async threadId => {
    return await wrapFetch(
      fetch(`/api/chat/${threadId}/read`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: 'application/json',
        },
      }),
    )
  },

  getUnreadCount: async () => {
    return await wrapFetch(
      fetch('/api/chat/unread-count', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: 'application/json',
        },
      }),
    )
  },

  markAllRead: async () => {
    return await wrapFetch(
      fetch('/api/chat/read-all', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: 'application/json',
        },
      }),
    )
  },

  archiveThread: async threadId => {
    return await wrapFetch(
      fetch(`/api/chat/${threadId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: 'application/json',
        },
      }),
    )
  },
}

export default ChatService
